import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { formatApiError, LOGO_URL } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); setMsg("Missing token"); return; }
    api.get(`/auth/verify-email?token=${token}`)
      .then(() => setStatus("ok"))
      .catch((e) => { setStatus("error"); setMsg(formatApiError(e)); });
  }, [params]);

  return (
    <div className="min-h-screen bg-blue-800 dark:bg-slate-950 flex flex-col" style={{ fontFamily: "'IBM Plex Sans', system-ui, sans-serif" }}>
      <div className="p-4"><Link to="/"><img src={LOGO_URL} alt="logo" className="h-12" /></Link></div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-3xl shadow-2xl p-8 border border-slate-200 dark:border-slate-800 text-center">
          {status === "verifying" && <div className="text-slate-600 dark:text-slate-300" data-testid="verify-status">Verifying…</div>}
          {status === "ok" && <>
            <div className="text-4xl mb-3">✅</div>
            <h1 className="text-2xl font-black text-slate-900 dark:text-white" data-testid="verify-status">Email verified!</h1>
            <p className="text-slate-500 mt-2">You can now sign in.</p>
            <Link to="/login" className="inline-block mt-4 rounded-full bg-blue-700 hover:bg-blue-800 text-white font-bold px-6 py-3 transition-colors duration-200">Sign in</Link>
          </>}
          {status === "error" && <>
            <h1 className="text-2xl font-black text-slate-900 dark:text-white" data-testid="verify-status">Verification failed</h1>
            <p className="text-slate-500 mt-2">{msg}</p>
          </>}
        </div>
      </div>
    </div>
  );
}
